import React, { useState } from 'react'
import Moment from 'react-moment';
import { Badge, Tooltip } from 'reactstrap';


const LicenseCellField = ({rowIndex, color, isBackedUp, isBackedUpRecent, lastBackup, fieldName}) => {

    const[tooltipOpen, setTooltipOpen] = useState(false)

    if (isBackedUp && isBackedUpRecent) {
        return (
            <>
                <span>
                    <Badge pill color='primary' style={{background: `${color}`}} id={`btn-${rowIndex}-recent`}>{fieldName}</Badge>
                </span>
                <Tooltip placement="top" isOpen={tooltipOpen} target={`btn-${rowIndex}-recent`} toggle={() => setTooltipOpen((prevCheck) => !prevCheck)}>
                    Last Backup: <Moment format='DD/MM/yyyy hh:mmA'>{lastBackup}</Moment>
                </Tooltip>
           </>
        )
    }
    else if (isBackedUp) {
        return (
            <>
                <span>
                    <Badge pill color='secondary' id={`btn-${rowIndex}-old`}>{fieldName}</Badge>
                </span>
                <Tooltip placement="top" isOpen={tooltipOpen} target={`btn-${rowIndex}-old`} toggle={() => setTooltipOpen((prevCheck) => !prevCheck)}>
                    Last Backup: <Moment format='DD/MM/yyyy hh:mmA'>{lastBackup}</Moment>
                </Tooltip>
            </>
        )
    }
    else {
        return <span></span>
    }
}

const LicenseCell = ({cell, row, rowIndex, formatExtraData}) => { 
    return (
        <span>
            <LicenseCellField rowIndex={rowIndex} color={'#0059b8'} isBackedUp={row.isMailboxBackedUp} isBackedUpRecent={row.isMailboxBackedUpRecent} lastBackup={row.lastMailboxBackup} fieldName="Mailbox" />{' '}
            <LicenseCellField rowIndex={rowIndex} color={'#6785c6'} isBackedUp={row.isArchiveBackedUp} isBackedUpRecent={row.isArchiveBackedUpRecent} lastBackup={row.lastArchiveBackup} fieldName="Archive" />{' '}
            <LicenseCellField rowIndex={rowIndex} color={'#0097b8'}isBackedUp={row.isOneDriveBackedUp} isBackedUpRecent={row.isOneDriveBackedUpRecent} lastBackup={row.lastOneDriveBackup} fieldName="One-Drive" />
        </span>
    )
}

export default LicenseCell;
